import { IUser } from '@shs-digi-care-monorepo/interfaces';

export function fullName(user: IUser | undefined | null): string {
    if (!user) return '-';
    return `${user.firstName} ${user.lastName}`;
}

export function initials(user: IUser | undefined | null): string {
    if (!user) return 'XX';
    return `${user.firstName[0]}${user.lastName[0]}`;
}

export function initialsFromName(name: string | null | undefined): string {
    if (!name) return '';
    return name
        .split(' ')
        .filter(Boolean)
        .map((word) => word[0].toUpperCase())
        .slice(0, 2)
        .join('');
}
